const isNumber = (value) => typeof value === "number";

export { isNumber };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/utils/dist/is-number.es.js
// module id = zn0N
// module chunks = 0